<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-[#e5e7eb]"></div>
    <!-- <Header /> --> 

     <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <div class="w-full h-full p-5 lg:p-10 flex flex-col gap-5">
      <div class="w-full flex justify-between items-center">
        <h1 class="text-lg lg:text-2xl font-semibold dark_text">
          Attendance List
        </h1>
      </div>

      <div v-if="loading" class="flex items-center justify-center">
        <img src="@/assets/attendance/loading.gif" alt="" />
      </div>
      <div v-else>
        <div v-if="studentList.length > 0" class="flex flex-col gap-5">
          <div
            class="flex flex-col justify-between text-sm gap-5 lg:flex-row lg:justify-start lg:items-center lg:gap-6 py-3"
          >
            <!-- Total -->
            <div
              class="bg-white border rounded-md w-full lg:w-[150px] h-[80px] flex flex-col justify-center items-center gap-2"
            >
              <h2 class="font-semibold text-black">Total</h2>
              <p id="total_std" class="font-light">
                {{ attendance_list.total_students }}
              </p>
            </div>

            <!-- Present -->
            <div
              class="bg-white border rounded-md w-full lg:w-[150px] h-[80px] flex flex-col justify-center items-center gap-2"
            >
              <h2 class="font-semibold text-black">Present</h2>
              <p id="present_std" class="font-light">
                {{ attendance_list.total_students - filteredStudents.length }}
              </p>
            </div>

            <!-- Absent -->
            <div
              class="bg-white border rounded-md w-full lg:w-[150px] h-[80px] flex flex-col justify-center items-center gap-2"
            >
              <h2 class="font-semibold text-black">Absent</h2>
              <p id="absent_std" class="font-light">
                {{ filteredStudents.length }}
              </p>
            </div>

            <!-- Attendance % -->
            <div
              class="bg-white border rounded-md w-full lg:w-[150px] h-[80px] flex flex-col justify-center items-center gap-2"
            >
              <h2 class="font-semibold text-black">Attendance %</h2>
              <p id="std_attendance" class="font-light">
                {{
                  (
                    ((attendance_list.total_students - uncheckedItems.length) /
                      attendance_list.total_students) *
                    100
                  ).toFixed(0)
                }}%
              </p>
            </div>

            <!-- Date / Session -->
            <div
              class="bg-white border rounded-md w-full lg:w-[150px] h-[80px] flex flex-col justify-center items-center gap-2"
            >
              <h2 class="font-semibold text-black mt-4">Date / Session</h2>
              <div class="text-center mb-2">
                {{ this.session }}
                <!-- <span class="text-xs">10-Apr-2025</span><br />
            <span class="text-xs">9.25AM - 10.20AM</span> -->
              </div>
            </div>
          </div>

          <div class="w-full overflow-scroll max-h-[630px]">
            <table class="min-w-full">
              <thead
                class="bg-[#18469d] border-b text-start text-white whitespace-nowrap sticky top-0"
              >
                <tr
                  class="text-sm font-semibold text-gray-100 text-left capitalize"
                >
                  <!-- <th class="px-6 py-3">S.No</th> -->
                  <th class="px-6 py-3">Student ID</th>
                  <th class="px-6 py-3">Name</th>
                  <th class="px-6 py-3">Student USN</th>
                  <th class="px-6 py-3">Attendance</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(student, index) in attendance_list.students"
                  :key="index"
                  class="border-b hover:bg-gray-200 bg-white text-xs lg:text-sm text-gray-900 font-normal whitespace-nowrap"
                >
                  <!-- <td class="px-6 py-2">{{ index + 1 }}</td> -->
                  <td class="px-6 py-2">{{ student.academic_info_pk }}</td>
                  <td class="px-6 py-2 capitalize text-left">
                    {{ student.display_name }}
                  </td>
                  <td class="px-6 py-2 capitalize text-left">
                    {{ student.university_seat_number }}
                  </td>
                  <td class="px-6 py-2">
                    <!-- <input
                  type="checkbox"
                  :checked="student.id"
                  class="attendance-checkbox"
                /> -->

                    <!-- <input
                  type="checkbox"
                  :checked="student.id"
                  :value="student.id"
                  @change="pushId(student.id)"
                  name=""
                  id=""
                /> -->

                    <input
                      type="checkbox"
                      :value="student.academic_info_pk"
                      :checked="
                        !uncheckedItems.includes(student.academic_info_pk)
                      "
                      @change="toggleItem(student.academic_info_pk)"
                    />
                  </td>
                </tr>
              </tbody>

              <tfoot class="sticky bottom-0">
                <tr>
                  <td colspan="10" class="p-6 bg-[#18469d]"></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="w-full flex justify-end items-center">
            <button
              @click="add_class = true"
              class="attendance_btn px-4 py-2 rounded-lg text-xs font-semibold"
            >
              Preview
            </button>
          </div>
        </div>
        <div v-else class="flex justify-center">No Data Found</div>
      </div>
    </div>

    <div
      v-if="add_class"
      @click.self="add_class = false"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 text-left gap-y-5 flex flex-col justify-center w-full max-h-[70%] lg:w-[70%] rounded-xl relative !z-999"
      >
        <h1>Absent: {{ uncheckedItems.length }}</h1>

        <div class="w-full overflow-scroll">
          <table class="min-w-full">
            <thead
              class="bg-[#18469d] border-b text-start text-white whitespace-nowrap sticky top-0"
            >
              <tr
                class="text-sm font-semibold text-gray-100 text-left capitalize"
              >
                <!-- <th class="px-6 py-3">S.No</th> -->
                <th class="px-6 py-3">Student ID</th>
                <th class="px-6 py-3">Name</th>
                <th class="px-6 py-3">Student USN</th>
                <th class="px-6 py-3">Attendance</th>
                <th class="px-6 py-3">Course</th>
                <th class="px-6 py-3">Subject Name</th>
                <th class="px-6 py-3">Subject Code</th>
                <th class="px-6 py-3">Section</th>
                <th class="px-6 py-3">Session</th>
              </tr>
            </thead>
            <tbody v-if="filteredStudents.length > 0" class="">
              <tr
                v-for="(student, index) in filteredStudents"
                :key="index"
                class="border-b hover:bg-gray-200 bg-white text-xs lg:text-sm text-gray-900 font-normal whitespace-nowrap"
              >
                <!-- <td class="px-6 py-2">{{ index + 1 }}</td> -->
                <td class="px-6 py-2">{{ student.academic_info_pk }}</td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ student.display_name }}
                </td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ student.university_seat_number }}
                </td>
                <td class="px-6 py-2 text-black">
                  <input type="checkbox" :value="student.id" />
                  <!-- {{ student.id }} -->
                </td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ currentData.course }}
                </td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ currentData.subject }}
                </td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ currentData.subject_code }}
                </td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ currentData.section }}
                </td>
                <td class="px-6 py-2 capitalize text-left">
                  {{ currentData.session }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="">
                <td colspan="9" class="px-6 py-2 text-center">No Absent</td>
              </tr>
            </tbody>
            <tfoot class="sticky bottom-0">
              <tr>
                <td colspan="12" class="p-6 bg-[#18469d]"></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div class="w-full flex justify-end items-center gap-5">
          <button
            @click="add_class = false"
            class="attendance_btn px-4 py-2 rounded-lg text-xs font-semibold"
          >
            Close
          </button>
          <button
            @click="freeze"
            class="attendance_btn px-4 py-2 rounded-lg text-xs font-semibold"
          >
            Freeze
          </button>
        </div>
      </div>
    </div>

    <!-- {{ namesList }} -->
    <!-- {{ currentData }} -->
    <!-- List ::{{ uncheckedItems }}
    {{ checkedItems }} -->
  </div>
</template>

<script>
// import Header from "@/components/Instructor/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";

import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

export default {
  data() {
    return {
      add_class: false,
      attendance_list: [],
      uncheckedItems: [],
      checkedItems: [],
      studentList: [],
      subject_list: [],
      messages: {
        text: "",
        type: "null",
      },
      currentData: "",
      namesList: [],
      loading: true
    };
  },

  props: ["subject_pk", "faculty_time_table_pk", "session"],

  components: { FlashMessage,   AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader, },
  created() {
    this.getStudentsList();
    this.getTodaySchedule();
    // this.getToken();
  },

  mounted() {
  },

  // computed: {
  // },

  computed: {
    filteredStudents() {
      return this.studentList.filter((student) =>
        this.uncheckedItems.includes(student.academic_info_pk)
      );
    },
    ...mapGetters(["userInfo"]),
  },

  methods: {

    getTodaySchedule() {
      axios
        .get(
          `${process.env.VUE_APP_API_COMS}/faculty-admin/today-schedule-attendance/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
          console.log("resp", resp);
          if (resp.data.status == 200) {
            this.subject_list = resp.data.data;
            this.currentData = this.subject_list.find(
              (i) => i.subject_pk == this.subject_pk
            );
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    freeze() {
      axios
        .post(
          `${process.env.VUE_APP_API_COMS}/faculty-admin/student-attendance-post/?time_table_pk=${this.faculty_time_table_pk}&Key=${localStorage.getItem("LmsId")}`,
          {
            student_id: this.checkedItems,
            name: this.namesList,
            attendance_status: this.uncheckedItems,
            course: Array(this.studentList.length).fill(
              this.currentData.course
            ),
            subject_code: Array(this.studentList.length).fill(
              this.currentData.subject_code
            ),
            subject_name: Array(this.studentList.length).fill(
              this.currentData.subject
            ),
            section: Array(this.studentList.length).fill(
              this.currentData.section
            ),
            session: Array(this.studentList.length).fill(
              this.currentData.session
            ),
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.add_class = false;
              this.messages = {
                text: "",
                type: "null",
              };
              this.$router.push({ name: "AttendanceView" });
            }, 1500);
          } else {
            this.messages = {
              text: response.data.error,
              type: "error",
            };
            setTimeout(() => {
              this.add_class = false;
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    toggleItem(id) {
      const index = this.uncheckedItems.indexOf(id);
      if (index === -1) {
        this.uncheckedItems.push(id);
        // this.checkedItems.splice(this.checkedItems.indexOf(id), 1);
        // this.namesList.splice(this.namesList.indexOf(this.studentList.find(i=> i.academic_info_pk == id).display_name), 1);
      } else {
        this.uncheckedItems.splice(index, 1);
        // this.checkedItems.push(id);
        // this.namesList.push(this.studentList.find(i=> i.academic_info_pk == id).display_name);
      }
    },

    async getStudentsList() {
      // https://coms.cambridge.edu.in/faculty-admin/student-attendance-list/%3Csubject_pk%3E/%3Cfaculty_time_table_pk%3E/?Key=${localStorage.getItem("LmsId")}

      await axios
        .get(
          `${process.env.VUE_APP_API_COMS}/faculty-admin/student-attendance-list/${this.subject_pk}/${this.faculty_time_table_pk}/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.attendance_list = response.data.data;
            this.studentList = response.data.data.students;
            setTimeout(() => {
              this.loading = false;
            }, 600);

            for (let i = 0; i < this.studentList.length; i++) {
              this.checkedItems.push(this.studentList[i].academic_info_pk);
              this.namesList.push(this.studentList[i].display_name);
            }

            // this.attendance_list = response.data.data.students.map(student => {
            //   student.attendance = false;
            //   return student;
            // });
            // for student in students:
            //   student["attendance"] = False
          }
        });
    },
  },
};
</script>

<style></style>
